export const mapStyle = googlemap_scripts.mapStyleGm;
